module.exports = __webpack_public_path__ + "img/jp-header.0bba8370.png";